/* pl-mini-cart.js
   Cart drawer recommendations lazy-loader, externalized from the inline
   <script> at the end of sections/mini-cart.liquid. Runs deferred; it only
   attaches listeners to #mini-cart, which exists once the document has parsed.
   Lives outside <cart-drawer> in the section so it survives drawer innerHTML
   replacements (theme.js swaps cart-drawer contents on cart:updated). */

// Lazy load cart recommendations - persist across cart HTML replacements
(function() {
  let recommendationsLoaded = false;
  const cartDrawer = document.getElementById('mini-cart');
  
  if (!cartDrawer) return;

  function fixLazyImages() {
    cartDrawer.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.removeAttribute('loading');
    });
  }
  
  function loadRecommendations() {
    const recommendationsWrapper = document.querySelector('[data-lazy-recommendations]');
    if (recommendationsWrapper) {
      recommendationsWrapper.removeAttribute('hidden');
      recommendationsLoaded = true;
    }

    fixLazyImages();

    var recsEl = cartDrawer.querySelector('cart-drawer-recommendations');
    if (recsEl) {
      new MutationObserver(function(mutations, obs) {
        var imgs = recsEl.querySelectorAll('img[loading="lazy"]');
        if (imgs.length) {
          imgs.forEach(function(img) { img.removeAttribute('loading'); });
          obs.disconnect();
        }
      }).observe(recsEl, { childList: true, subtree: true });
    }
  }
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (cartDrawer.hasAttribute('open')) {
          loadRecommendations();
        }
      }
    });
  });
  
  observer.observe(cartDrawer, { attributes: true });
  
  if (cartDrawer.hasAttribute('open')) {
    loadRecommendations();
  }
  
  const cartContentObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type !== 'childList') return;

      // Un-lazy immediately and unconditionally. The drawer sits at
      // translateX(100%) so its images never intersect the viewport, which
      // means loading="lazy" defers them until something makes them eligible.
      // Previously that only happened inside loadRecommendations(), i.e. when
      // the `open` attribute appeared - so the thumbnail fetch started at the
      // same instant the 350ms slide began, and on the first add of a session
      // it did not run here at all (it was gated on recommendationsLoaded).
      // Firing on injection starts the download during the slide instead.
      fixLazyImages();

      if (recommendationsLoaded) {
        setTimeout(function() {
          const newRecommendationsWrapper = document.querySelector('[data-lazy-recommendations]');
          if (newRecommendationsWrapper && newRecommendationsWrapper.hasAttribute('hidden')) {
            newRecommendationsWrapper.removeAttribute('hidden');
          }
          fixLazyImages();
        }, 10);
      }
    });
  });
  
  cartContentObserver.observe(cartDrawer, { 
    childList: true, 
    subtree: false
  });

  // Earliest possible trigger: the cart:refresh event fires on documentElement
  // as soon as /cart/add.js resolves, ahead of the drawer opening.
  document.documentElement.addEventListener('cart:refresh', fixLazyImages);
  document.documentElement.addEventListener('cart:updated', fixLazyImages);

  // Intent warming: hovering or focusing the cart toggle is a strong signal the
  // drawer is about to open, so start the thumbnails then rather than on click.
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[aria-controls="mini-cart"]')) fixLazyImages();
    }, { passive: true, capture: true });
  });

  // Desktop arrow navigation for the recommendations carousel. Delegated on the
  // persistent cart-drawer element so it keeps working after the cart re-renders.
  if (!cartDrawer.dataset.recsNavBound) {
    cartDrawer.dataset.recsNavBound = '1';

    var updateRecsArrows = function(list) {
      var scroller = list.closest('.scroller');
      if (!scroller) return;
      var prev = scroller.querySelector('[data-recs-prev]');
      var next = scroller.querySelector('[data-recs-next]');
      var atStart = list.scrollLeft <= 2;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      if (prev) prev.classList.toggle('is-hidden', atStart);
      if (next) next.classList.toggle('is-hidden', atEnd);
    };

    cartDrawer.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-recs-prev], [data-recs-next], [data-recent-prev], [data-recent-next]');
      if (!btn) return;
      var isRecent = btn.hasAttribute('data-recent-prev') || btn.hasAttribute('data-recent-next');
      var isNext = btn.hasAttribute('data-recs-next') || btn.hasAttribute('data-recent-next');
      var listSelector = isRecent ? '.mini-cart__recent-track' : '.mini-cart__recommendations-list';
      var scroperSelector = isRecent ? '.mini-cart__recent-scroller' : '.scroller';
      var scroller = btn.closest(scroperSelector);
      var list = scroller && scroller.querySelector(listSelector);
      if (!list) return;
      var amount = list.clientWidth * 0.85;
      list.scrollBy({ left: isNext ? amount : -amount, behavior: 'smooth' });
    });

    // Scroll events do not bubble, so we listen in the capture phase on the
    // persistent drawer to catch the recs list scrolling (arrow clicks or
    // trackpad swipes) and reveal/hide the prev/next arrows accordingly.
    cartDrawer.addEventListener('scroll', function(e) {
      var el = e.target;
      if (!el || !el.classList) return;
      if (el.classList.contains('mini-cart__recommendations-list')) {
        updateRecsArrows(el);
      } else if (el.classList.contains('mini-cart__recent-track')) {
        var scroller = el.closest('.mini-cart__recent-scroller');
        if (!scroller) return;
        var prev = scroller.querySelector('[data-recent-prev]');
        var next = scroller.querySelector('[data-recent-next]');
        var atStart = el.scrollLeft <= 2;
        var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
        if (prev) prev.classList.toggle('is-hidden', atStart);
        if (next) next.classList.toggle('is-hidden', atEnd);
      }
    }, true);
  }
})();
